import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  container: {
    width: 200,
    display: "flex",
    alignItems: "center",
  },
  icon: {
    marginRight: 40,

    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",

    "& svg": {
      cursor: "pointer",
      transition: "transform 0.4s ease, opacity 0.3s ease",
      transformOrigin: "center",
    },

    "&:hover svg": {
      transform: "scale(1.4)",
      opacity: 0.85,
    },

    "&:nth-last-of-type(2)": {
      marginRight: 28,
    },

    "&:last-of-type": {
      marginRight: 0,
    },
  },

  "social-chat": {
    width: 50,
    height: 50,
    background: "#192031",
    borderRadius: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    transition: "all 0.4s ease-in-out",

    "& svg": {
      transition: "all 0.4s ease-in-out",
    },

    "&:hover": {
      background: "#2a3247",
      transform: "scale(1.06)",
    },

    "&:hover svg": {
      transform: "scale(1.06)",
    },
  },
}));

export default useStyles;
